import { render } from "./authPopup.vue?vue&type=template&id=e2b3fae8&scoped=true"
import script from "./authPopup.vue?vue&type=script&lang=js"
export * from "./authPopup.vue?vue&type=script&lang=js"

import "./authPopup.vue?vue&type=style&index=0&id=e2b3fae8&scoped=true&lang=css"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b3fae8"]])

export default __exports__